__turbopack_context__.v({
  "checkout": "cart-module__Jmky-G__checkout",
  "item": "cart-module__Jmky-G__item",
  "items": "cart-module__Jmky-G__items",
  "layout": "cart-module__Jmky-G__layout",
  "page": "cart-module__Jmky-G__page",
});
